import React from 'react';
import styles from './InsightsCards.module.scss';
import Image from 'next/image';
import Button, { PRIMARY_THEME } from 'components/control/button';
import { buildClassName } from 'utils/build-class-name';

// Hardcoding cards until insights are officially launched on WordPress
// TODO: we should delete after WordPress is launched along with the images in /assets/images/insights-fixtures
const cards = [
  {
    title: 'North Star Commercial Real Estate Advisors Joins eXp Commercial to Unlock Nationwide Reach and New Growth Opportunities',
    subtitle: 'Meet Our Agents',
    date: 'May 29, 2025',
    url: 'https://life.exprealty.com/north-star-commercial-real-estate-joins-exp-commercial/',
    image: '/assets/images/insights-fixtures/image.png',
  },
  {
    title: 'See Why eXp Commercial Is Turning Heads In the Commercial Real Estate Brokerage Space',
    subtitle: 'About eXp',
    date: 'February 11, 2025',
    url: 'https://life.exprealty.com/top-reasons-to-join-exp-commercial/',
    image: '/assets/images/insights-fixtures/image-2.png',
  },
  {
    title: 'The Commercial Real Estate Market: What Is in Store for 2025?',
    subtitle: 'Real Estate Insights',
    date: 'January 7, 2025',
    url: 'https://life.exprealty.com/commercial-real-estate-market-2025-outlook/',
    image: '/assets/images/insights-fixtures/image-3.png',
  },
  {
    title: 'eXp Commercial Expands Technology Suite, Giving Advisors Access to CoStar’s Advanced Data Platform and LoopNet Discounts',
    subtitle: 'eXp in the News',
    date: 'December 12, 2024',
    url: 'https://life.exprealty.com/exp-commercial-adds-costar-data-loopnet-discounts/',
    image: '/assets/images/insights-fixtures/image-4.png',
  },
];

const InsightsCards = () => {
  return (
    <section className={styles.component}>
      <div className={styles.headerRow}>
        <h2 className={styles.heading}>INSIGHTS</h2>
        <a
          href="/insights"
          className={styles.viewAllBtn}
        >
          <Button label={'View All Insights'} theme={PRIMARY_THEME}/>
        </a>
      </div>
      <div className={styles.cardsWrapper}>
        {cards.map((card, idx) => (
          <a
            key={idx}
            href={card.url}
            className={styles.card}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className={styles.imageWrapper}>
              <Image src={card.image} alt={card.title} fill sizes="(max-width: 600px) 100vw, 25vw" />
            </div>
            <div className={styles.cardContent}>
              <div className={styles.subtitle}>{card.subtitle}</div>
              <div className={styles.title}>{card.title}</div>
              <div className={styles.date}>{card.date}</div>
            </div>
          </a>
        ))}
      </div>
      <a
        href="https://life.exprealty.com/insights/"
        className={buildClassName(styles.viewAllBtn, styles.viewAllBtnMobile)}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Button label={'View All Insights'} theme={PRIMARY_THEME}/>
      </a>
    </section>
  );
};

export default InsightsCards; 